// src/services/whatsApp_service.tsx

import apiClient from "./api_client";

/**
 * Interface for booking a drone order
 */
export interface BookDroneRequest {
  droneId: number;
  startDate: string;
  endDate: string;
}

/**
 * Interface for booking response
 */
export interface BookDroneResponse {
  success: boolean;
  message: string;
  orderId?: number;
  whatsappUrl?: string;
}

/**
 * WhatsApp Service for handling drone booking via WhatsApp
 */
class WhatsAppService {
  /**
   * Book a drone order
   * @param droneId - The ID of the drone to book
   * @returns Promise with booking response
   */
  public async bookDrone(
    droneId: number,
    startDate: string,
    endDate: string
  ): Promise<BookDroneResponse> {
    try {
      const response = await apiClient.post<BookDroneResponse>(
        '/orders/book',
        { droneId, startDate, endDate }
      );
      return response;
    } catch (error) {
      console.error('Error booking drone:', error);
      throw error;
    }
  }
}

// Create and export a single instance
const whatsAppService = new WhatsAppService();
export default whatsAppService;
